/**
 * The login page shows a banner when the application redirects a user back to
 * it. The message is never taken from the URL: the URL carries only one of the
 * codes below, and the text shown is chosen here. Anything unrecognised shows
 * no banner at all.
 */
export enum LoginMessageCode {
  Unauthorized = 'unauthorized',
  DifferentLocation = 'different_location',
  SessionExpired = 'session_expired',
}

export const LOGIN_MESSAGES: Readonly<Record<LoginMessageCode, string>> = {
  [LoginMessageCode.Unauthorized]: 'Please login to continue',
  [LoginMessageCode.DifferentLocation]:
    'You have been logged out because your account was accessed from a different location.',
  [LoginMessageCode.SessionExpired]:
    'We detected that you are logging in from a new location. For security, your session has expired. Please login again to continue.',
};

export function getLoginMessageForCode(code: unknown): string | null {
  if (
    typeof code !== 'string' ||
    !Object.prototype.hasOwnProperty.call(LOGIN_MESSAGES, code)
  ) {
    return null;
  }
  return LOGIN_MESSAGES[code as LoginMessageCode];
}
